export default __webpack_public_path__ + "static/media/1230.c91a01e3.png";